import React, { useEffect, useState } from "react";
import _ from "lodash";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import Input from "@amzn/meridian/input";
import Text from "@amzn/meridian/text";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import plusCircleTokens from "@amzn/meridian-tokens/base/icon/plus-circle";

interface IEditDatesTableProps {
    data: {
        importantDates?: {
            [key: string]: string;
        };
    };
    handleInputChange: any;
}

export const EditDatesTable: React.FC<IEditDatesTableProps> = ({ data, handleInputChange }) => {
    const [newDateName, setNewDateName] = useState("");
    const [newDateValue, setNewDateValue] = useState("");
    const [importantDates, setImportantDates] = useState<Record<string, string>>({});

    useEffect(() => {
        setImportantDates(
            _.get(data, "appealDetails.appealApproachCalculationData.summary.importantDates", {})
        );
    }, [data]);

    const handleDelete = (key: string) => {
        const updatedDates = _.omit(importantDates, key);
        updateImportantDates(updatedDates);
    };

    const handleAdd = () => {
        if (newDateName && newDateValue) {
            const updatedDates = {
                ...importantDates,
                [newDateName]: newDateValue,
            };
            updateImportantDates(updatedDates);
            setNewDateName("");
            setNewDateValue("");
        }
    };

    const updateImportantDates = (updatedDates: Record<string, string>) => {
        handleInputChange(
            "appealDetails.appealApproachCalculationData.summary.importantDates",
            updatedDates
        );
    };

    return (
        <Table headerRows={1}>
            <TableRow>
                <TableCell width={200}>Date Name</TableCell>
                <TableCell width={200}>Date</TableCell>
                <TableCell width={50} />
            </TableRow>
            {Object.entries(importantDates).map(([key, value]) => (
                <TableRow key={key}>
                    <TableCell width={200}>
                        <Text>{key}</Text>
                    </TableCell>
                    <TableCell width={200}>
                        <Text>{value || ""}</Text>
                    </TableCell>
                    <TableCell alignmentHorizontal="end">
                        <Button type="icon" onClick={() => handleDelete(key)}>
                            <Icon tokens={trashTokens} />
                        </Button>
                    </TableCell>
                </TableRow>
            ))}
            <TableRow>
                <TableCell width={200}>
                    <Input size="small" value={newDateName} onChange={setNewDateName} />
                </TableCell>
                <TableCell width={200}>
                    <Input
                        size="small"
                        type="date"
                        value={newDateValue}
                        onChange={setNewDateValue}
                    />
                </TableCell>
                <TableCell alignmentHorizontal="end">
                    <Button type="icon" onClick={handleAdd}>
                        <Icon tokens={plusCircleTokens} color="primary" />
                    </Button>
                </TableCell>
            </TableRow>
        </Table>
    );
};
